export default "__VITE_ASSET__52e6f0a5__"